import { error } from 'console';
import { FC, PropsWithChildren } from 'react';
import { icons } from '../../../icons/IconSet';

const Alert: FC<PropsWithChildren<{
  severity?: 'error' | 'warning' | 'info' | 'success',
  size?: 'small' | 'medium' | 'large',
  title?: string,
  noIcon?: boolean, 
}>> = ({
  severity = 'error',
  size = 'medium',
  title,
  noIcon = false,
  children,
}) => {

  return (
    <div className={`flex gap-4 items-center
      ${{
        error: ' bg-red-50 text-red-600',
        warning: '',
        info: '',
        success: '',
      }?.[severity]}
      ${{
          small: '',
          medium: 'p-3',
          large: '',
        }[size]}
    `}>
      {!noIcon && {
        error: icons('triangle-alert', {
          stroke: 'red',
          width: {
            small: '',
            medium: '1.5em',
            large: '',
          }[size]
        }),
        warning: '',
        info: '',
        success: '',
      }?.[severity] || <></>}
      {children}
    </div>
  );
}

export default Alert;
